/**
 * Auto-generated from dark-roast enum types — string-literal union types
 * derived from the Java backend's wire enum values. Do not edit manually.
 * Regenerate with: yarn sync-entities
 */

export enum InterviewStatusType {
  Cancelled = "Cancelled",
  Confirmed = "Confirmed",
  Live = "Live",
  Past = "Past",
  Requested = "Requested",
  Scheduled = "Scheduled",
  Today = "Today",
  Unknown = "Unknown",
  Upcoming = "Upcoming",
}

export const InterviewStatusTypeDisplay: Record<InterviewStatusType, string> = {
  [InterviewStatusType.Cancelled]: "Cancelled",
  [InterviewStatusType.Confirmed]: "Confirmed",
  [InterviewStatusType.Live]: "Live",
  [InterviewStatusType.Past]: "Past",
  [InterviewStatusType.Requested]: "Requested",
  [InterviewStatusType.Scheduled]: "Scheduled",
  [InterviewStatusType.Today]: "Today",
  [InterviewStatusType.Unknown]: "Unknown",
  [InterviewStatusType.Upcoming]: "Upcoming",
};
